/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Badge, OverlayTrigger, Tooltip, Alert, Clearfix } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';
import { find as _find, filter as _filter } from 'lodash';
import moment from 'moment';
import 'moment-timezone';

import { watchLead, unwatchLead } from 'actions/LeadActions';
import { addNotification } from 'actions/NotificationsActions';
import { clientSingleOptionFormatter, clientOptionFromEntity } from 'components/forms/autocomplete/Client';
import { getLeadRowData, getLeadPriorities, getChannelTypes } from 'helpers/leads';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import RichEditorContent from 'components/RichEditorContent';
import List from 'components/List';

import IntlDate from 'components/layout/IntlDate';
import IntlDateTime from 'components/layout/IntlDateTime';
import IntlDateRelative from 'components/layout/IntlDateRelative';
import TableResponsive from 'components/layout/TableResponsive';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';
import FormRichEditor from 'components/forms/FormRichEditor';
import DatePicker from 'components/forms/DatePicker';
import DateTimePicker from 'components/forms/DateTimePicker';
import FormTags from 'components/forms/FormTags';

import ClientNew from 'components/modals/ClientNew';

class LeadData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      showClientNew: false,
      showEmailContent: false,
      showSimiliarLeads: false,
      showEditTitle: false,
      showDesiredDomain: false,
      showEditDescription: false,
      showEditDueDate: false,
      showEditDeliveryDate: false,
    };
  }

  showClientNew = () => {
    this.setState({ showClientNew: true });
  };

  closeClientNew = () => {
    this.setState({ showClientNew: false });
  };

  showEditTitle = () => {
    this.setState({ showEditTitle: true });
  };

  isDomainLeadTask = entity => !!entity.getItems()?.[0]?.desiredDomain;

  showDesiredDomain = () => {
    this.setState({ showDesiredDomain: true });
  };

  setDesiredDomain = (name, value) => {
    this.updateEntity(name, value, ['items', 0]);
  };

  showEditDescription = () => {
    this.setState({ showEditDescription: true });
  };

  showEmailContent = e => {
    e.preventDefault();
    this.setState({ showEmailContent: true });
  };

  closeEmailContent = e => {
    e.preventDefault();
    this.setState({ showEmailContent: false });
  };

  showSimiliarLeads = e => {
    e.preventDefault();
    this.setState({ showSimiliarLeads: true });
  };

  closeSimiliarLeads = e => {
    e.preventDefault();
    this.setState({ showSimiliarLeads: false });
  };

  showEditDueDate = e => {
    e.preventDefault();
    this.setState({ showEditDueDate: true });
  };

  showEditDeliveryDate = e => {
    e.preventDefault();
    this.setState({ showEditDeliveryDate: true });
  };

  isWatching = () => {
    const { user, entity } = this.props;
    if (entity.getWatchingCount() > 0) {
      return !!_find(entity.getWatchingList(), ['id', user.username]);
    }

    return false;
  };

  watchUnwatchButton = id => {
    const isWatching = this.isWatching();
    const {
      intl: { messages },
      watchLead,
      unwatchLead,
    } = this.props;
    const { stop_watching_lead: stop, start_watching_lead: start } = messages;
    const text = isWatching ? stop : start;
    const handler = isWatching ? unwatchLead : watchLead;
    return (
      <button
        type="button"
        class="btn btn-default"
        onClick={e => {
          e.preventDefault();
          handler(id);
        }}
      >
        {text}
      </button>
    );
  };

  assignTarget = client => {
    this.closeClientNew();
    this.updateEntity('target', client);
  };

  updateDueDate = (name, value) => {
    this.updateEntityMultiple([name, 'isDueDateSetManually'], [value, true], [], this.dueDateUpdated);
  };

  dueDateUpdated = () => {
    /* this.dueDateUpdatedTimeout = setTimeout(() => {
      this.setState({ showEditDueDate: false });
    }, 3000); */
  };

  updateDeliveryDate = (name, value) => {
    this.updateEntity(name, value, [], this.deliveryDateUpdated);
  };

  deliveryDateUpdated = () => {
    this.deliveryDateUpdatedTimeout = setTimeout(() => {
      this.setState({ showEditDeliveryDate: false });
    }, 3000);
  };

  resetDeliveryDate = e => {
    e.stopPropagation();
    this.updateEntity('deliveryDate', null);
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      user,
      watching,
      commentNewFormStatus,
      doNotify,
    } = this.props;

    if (prevProps.watching.pending && !watching.pending && !watching.hasError) {
      if (watching.last === 'watch') {
        const newWatchingList = this.props.entity.getWatchingList().slice();
        newWatchingList.push({
          id: user.username,
          name: user.profile.first_name + ' ' + user.profile.last_name,
        });
        this.updateEntityMultiple(
          ['watchingList', 'watchingCount'],
          [newWatchingList, this.props.entity.getWatchingCount() + 1]
        );

        doNotify(1, messages.watching_lead);
      } else if (watching.last === 'unwatch') {
        const newWatchingList = [];
        this.props.entity.getWatchingList().forEach(watcher => {
          if (watcher.id !== user.username) {
            newWatchingList.push(watcher);
          }
        });
        this.updateEntityMultiple(
          ['watchingList', 'watchingCount'],
          [newWatchingList, this.props.entity.getWatchingCount() - 1],
          [],
          null,
          false
        );

        doNotify(1, messages.no_longer_watching_lead);
      }
    }

    if (prevProps.commentNewFormStatus.pending && !commentNewFormStatus.pending && !commentNewFormStatus.hasError) {
      const comments = this.props.entity.getComments();
      comments.splice(0, 0, this.props.entity.createValue('comments', [], commentNewFormStatus.response));
      this.updateEntity('comments', comments, [], null, false);
    }
  };

  componentWillUnmount = () => {
    clearTimeout(this.dueDateUpdatedTimeout);
    clearTimeout(this.deliveryDateUpdatedTimeout);
  };

  render() {
    const {
      webApp,
      intl: { messages },
      appIntl,
      entity,
      entityLoaded,
      disabled,
      inModal,
      user,
      similiarLeads,
    } = this.props;
    const { showEditDeliveryDate, showEditDueDate, showEditTitle, showDesiredDomain, showEditDescription } = this.state;
    const checkIfOrder = 'Bestellung';

    const highlightMyProfile = {
      isHighlighted: true,
      highlightTitle: messages.assign_to_me,
      ...clientSingleOptionFormatter(user),
    };
    const timezone = user && user.profile ? user.profile.timezone : 'UTC';
    const minDueDate = moment()
      .subtract(1, 'days')
      .endOf('day');

    if (entityLoaded) {
      const momentWeekAgo = moment()
        .subtract(7, 'days')
        .startOf('day');
      const createdDate = moment(entity.getCdate()).isAfter(momentWeekAgo) ? (
        <IntlDateRelative date={entity.getCdate()} />
      ) : (
        <IntlDate date={entity.getCdate()} />
      );
      const modifiedDate = moment(entity.getMdate()).isAfter(momentWeekAgo) ? (
        <IntlDateRelative date={entity.getMdate()} />
      ) : (
        <IntlDate date={entity.getMdate()} />
      );
      const closedDate = '-';

      let shouldFetchSimiliarLeads = false;
      const similiarLeadsUrlData = {};
      const target = entity?.getTarget?.()?.getUsername?.();
      if (target) {
        shouldFetchSimiliarLeads = true;
        similiarLeadsUrlData.filters = { target };
      } else if (entity.getDescription()) {
        // check if there is an email address in the description
        const matches = entity
          .getDescription()
          .match(/[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/);
        if (matches) {
          shouldFetchSimiliarLeads = true;
          const [search] = matches;
          similiarLeadsUrlData.search = search;
        }
      }

      return (
        <div className="clearfix p-t-15 p-b-15">
          {shouldFetchSimiliarLeads && (
            <List
              noRender
              listName="similiarLeads"
              url="/api/leads.json"
              urlData={similiarLeadsUrlData}
              list={similiarLeads}
            />
          )}

          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              {shouldFetchSimiliarLeads && !similiarLeads.pending && similiarLeads.data.count > 1 && (
                <div className="m-b-20">
                  <Alert bsStyle="info" className="no-margin">
                    <Clearfix>
                      <p className="col-xs-6 no-padding no-margin">
                        <FormattedMessage
                          id="we_found_count_similar_leads"
                          values={{ count: similiarLeads.data.count }}
                        />
                      </p>
                      <p className="text-right no-margin bold">
                        {this.state.showSimiliarLeads ? (
                          <a href="#closeSimiliarLeads" onClick={this.closeSimiliarLeads}>
                            ×
                          </a>
                        ) : (
                          <a href="#showSimiliarLeads" onClick={this.showSimiliarLeads}>
                            {messages.show_similiar_leads}
                          </a>
                        )}
                      </p>
                    </Clearfix>
                  </Alert>

                  <AnimateHeight duration={300} height={this.state.showSimiliarLeads ? 'auto' : 0}>
                    <TableResponsive
                      headers={{ pipeline: messages.pipeline, lead: messages.lead, assignee: messages.assignee }}
                      rows={_filter(similiarLeads.data.list, lead => {
                        return lead.id !== entity.getId();
                      }).map(lead => {
                        const detailsUrl = appIntl.urlPrefix + 'account/leads/' + lead.id;
                        const rowData = getLeadRowData(lead, messages, appIntl, () =>
                          this.props.history.push(detailsUrl)
                        );
                        delete rowData.client;
                        delete rowData.actions;

                        return rowData;
                      })}
                      hover
                    />
                  </AnimateHeight>
                </div>
              )}

              {/* show information about email if the lead was created from a lead catcher */}
              {!!entity.getCreatedFromEmail() && (
                <div className="m-b-20">
                  <Alert bsStyle="info" className="no-margin">
                    <Clearfix>
                      <p className="col-xs-6 no-padding no-margin">{messages.lead_created_from_an_email}</p>
                      <p className="text-right no-margin bold">
                        {this.state.showEmailContent ? (
                          <a href="#closeEmailContent" onClick={this.closeEmailContent}>
                            ×
                          </a>
                        ) : (
                          <a href="#showEmailContent" onClick={this.showEmailContent}>
                            {messages.show_original_message}
                          </a>
                        )}
                      </p>
                    </Clearfix>
                  </Alert>

                  <AnimateHeight duration={300} height={this.state.showEmailContent ? 'auto' : 0}>
                    <div className="no-overflow">
                      <RichEditorContent
                        content={'<div class="m-t-15 b-l b-grey p-l-10">' + entity.getEmailContent() + '</div>'}
                      />
                    </div>
                  </AnimateHeight>
                </div>
              )}
              {entity.getTitle() !== checkIfOrder && (
                <>
                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div className="form-group-attached">
                    {showDesiredDomain ? (
                      <FormInput
                        label={messages.desired_domain}
                        name="desiredDomain"
                        value={entity.getItems()[0].desiredDomain}
                        // meta={entity.getTitleMetaInformation()}
                        validation={entity.getTitleValidationResult()}
                        onChange={this.setDesiredDomain}
                        disabled={disabled}
                      />
                    ) : (
                      <span>
                        {!!this.isDomainLeadTask(entity) && (
                          <div
                            className="form-group form-group-default p-t-10 p-b-10 cursor"
                            onClick={this.showDesiredDomain}
                          >
                            <label>
                              {messages.desired_domain} <i className="m-l-10 fa fa-pencil-alt" />
                            </label>
                            {entity.getItems()[0].desiredDomain}
                          </div>
                        )}
                      </span>
                    )}

                    {showEditTitle ? (
                      <FormInput
                        label={messages.title}
                        name="title"
                        value={entity.getTitle()}
                        meta={entity.getTitleMetaInformation()}
                        validation={entity.getTitleValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    ) : (
                      <div className="form-group form-group-default p-t-10 p-b-10 cursor" onClick={this.showEditTitle}>
                        <label>
                          {messages.title} <i className="m-l-10 fa fa-pencil-alt" />
                        </label>
                        {entity.getTitle()}
                      </div>
                    )}

                    {showEditDescription ? (
                      <FormRichEditor
                        label={messages.description}
                        name="description"
                        value={entity.getDescription()}
                        meta={entity.getDescriptionMetaInformation()}
                        validation={entity.getDescriptionValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                        initAtWho
                      />
                    ) : (
                      <div
                        className="form-group form-group-default p-t-10 p-b-10 cursor"
                        onClick={this.showEditDescription}
                      >
                        <label>
                          {messages.description} <i className="m-l-10 fa fa-pencil-alt" />
                        </label>
                        <RichEditorContent content={`<div>${entity.getDescription() || ''}</div>`} />
                      </div>
                    )}
                  </div>
                  <p className="m-t-10 form-group-title">{messages.deal_information}</p>
                  <div className="form-group-attached">
                    <FormInput
                      label={messages.reference_number}
                      name="referenceNumber"
                      value={entity.getReferenceNumber()}
                      meta={entity.getReferenceNumberMetaInformation()}
                      validation={entity.getReferenceNumberValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    {showEditDeliveryDate ? (
                      <DatePicker
                        value={entity.getDeliveryDate()}
                        locale={appIntl.locale}
                        displayTz={timezone}
                        onChange={this.updateDeliveryDate}
                        label={messages.delivery_date}
                        name="deliveryDate"
                        disabled={disabled}
                      />
                    ) : (
                      <div
                        className="form-group form-group-default p-t-10 p-b-10 cursor"
                        onClick={this.showEditDeliveryDate}
                      >
                        <label>
                          {messages.delivery_date} <i className="m-l-10 fa fa-pencil-alt" />
                        </label>
                        <Clearfix className="text-master">
                          {entity.getDeliveryDate() ? (
                            <IntlDate date={entity.getDeliveryDate()} />
                          ) : (
                            messages.edit_delivery_date
                          )}
                          {!!entity.getDeliveryDate() && (
                            <Button className="text-danger pull-right" bsSize="xsmall" onClick={this.resetDeliveryDate}>
                              <i className="fa fa-times" />
                            </Button>
                          )}
                        </Clearfix>
                      </div>
                    )}
                    <FormInput
                      prefixAddon={webApp.currencySymbol}
                      type="number"
                      label={messages.amount}
                      name="amount"
                      value={entity.getAmount()}
                      meta={entity.getAmountMetaInformation()}
                      validation={entity.getAmountValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      prefixAddon={webApp.currencySymbol}
                      type="number"
                      label={messages.budget}
                      name="budget"
                      value={entity.getBudget()}
                      meta={entity.getBudgetMetaInformation()}
                      validation={entity.getBudgetValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                  </div>
                </>
              )}
            </Col>

            <Col xs={12} md={inModal ? 12 : 6}>
              <p className="form-group-title">{messages.people}</p>
              <div className="form-group-attached">
                <FormAutocomplete
                  label={messages.assignee}
                  name="assignee"
                  value={clientOptionFromEntity(entity.getAssignee())}
                  meta={entity.getAssigneeMetaInformation()}
                  validation={entity.getAssigneeValidationResult()}
                  onChange={this.updateEntity}
                  returnValueObject
                  autocompleteType="user"
                  disabled={disabled}
                  urlFilters={{
                    filters: {
                      teams: entity
                        .getPipeline()
                        .getDefaultTeam()
                        .getId(),
                      isActive: true,
                    },
                  }}
                  highlightedOptions={[highlightMyProfile]}
                />
                {entity.getTitle() !== checkIfOrder && (
                  <Row className="clearfix">
                    <Col sm={entity.getTarget().getUsername() ? 12 : 8}>
                      <FormAutocomplete
                        label={messages.client}
                        name="target"
                        value={clientOptionFromEntity(entity.getTarget())}
                        meta={entity.getTargetMetaInformation()}
                        validation={entity.getTargetValidationResult()}
                        onChange={this.updateEntity}
                        returnValueObject
                        autocompleteType="client"
                        disabled={disabled}
                      />
                    </Col>
                    {!entity.getTarget().getUsername() && (
                      <Col sm={4}>
                        <div className="form-group form-group-default">
                          <label>{messages.client_not_found}</label>
                          <div className="text-right">
                            <Button block onClick={this.showClientNew}>
                              <i className="fa fa-plus m-r-10" /> {messages.create_client}
                            </Button>
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                )}
              </div>

              <p className="form-group-title m-b-10">{messages.watchers}</p>
              <div className="form-group-attached">
                {entity.getWatchingCount() > 0 ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="watchers-list">
                        {entity.getWatchingList().map(({ name }) => {
                          return <div key={name}>{name}</div>;
                        })}
                      </Tooltip>
                    }
                  >
                    <Badge className="m-r-10">{entity.getWatchingCount()}</Badge>
                  </OverlayTrigger>
                ) : (
                  <Badge className="m-r-10">0</Badge>
                )}

                {this.props.watching.pending ? (
                  <i className="fa fa-fw fa-circle-notch fa-spin" />
                ) : (
                  this.watchUnwatchButton(entity.getId())
                )}
              </div>

              <p className="form-group-title">{messages.settings}</p>
              <div className="form-group-attached">
                <FormAutocomplete
                  label={messages.priority}
                  name="priority"
                  value={entity.getPriority()}
                  meta={entity.getPriorityMetaInformation()}
                  validation={entity.getPriorityValidationResult()}
                  onChange={this.updateEntity}
                  disabled={disabled}
                  options={getLeadPriorities(messages).map(leadPriority => {
                    return {
                      value: leadPriority.value,
                      label: (
                        <span>
                          {leadPriority.icon} {leadPriority.label}
                        </span>
                      ),
                    };
                  })}
                />
                <FormTags
                  label={messages.tags}
                  name="tags"
                  value={entity.getTags()}
                  onChange={this.updateEntity}
                  disabled={disabled}
                  messages={messages}
                />
                {entity.getTitle() !== checkIfOrder && (
                  <>
                    <FormAutocomplete
                      label={messages.lead_channel}
                      name="channel"
                      value={entity.getChannel()}
                      meta={entity.getChannelMetaInformation()}
                      validation={entity.getChannelValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      options={getChannelTypes(messages)}
                    />

                    <div className="form-group form-group-default">
                      <label>{messages.source}</label>
                      <div>{entity.getSource() || '-'}</div>
                    </div>
                  </>
                )}
              </div>

              <p className="form-group-title m-b-10">{messages.dates}</p>
              <dl style={{ marginBottom: 0 }}>
                {entity.getTitle() !== checkIfOrder && (
                  <>
                    <dt>{messages.date_created}</dt>
                    <dd>{createdDate}</dd>
                  </>
                )}
                {entity.getIsDueDateSetManually() ? (
                  <dt className="m-t-5">{messages.due_date}</dt>
                ) : (
                  <dt className="m-t-5">{messages.current_stages_due_date}</dt>
                )}
                <dd>
                  {showEditDueDate ? (
                    <div className="form-group-attached">
                      <DateTimePicker
                        value={entity.getDueDate()}
                        minDate={minDueDate}
                        locale={appIntl.locale}
                        displayTz={timezone}
                        onChange={this.updateDueDate}
                        label={messages.due_date}
                        name="dueDate"
                        disabled={disabled}
                      />
                    </div>
                  ) : (
                    <>
                      <a href="#editDueDate" onClick={this.showEditDueDate}>
                        <span className="text-master">
                          <IntlDateTime date={entity.getDueDate()} />
                        </span>{' '}
                        <i className="m-l-10 fa fa-pencil-alt" />
                      </a>
                    </>
                  )}
                </dd>
                {entity.getTitle() !== checkIfOrder && (
                  <>
                    <dt className="m-t-5">{messages.date_updated}</dt>
                    <dd>{modifiedDate}</dd>
                    <dt className="m-t-5">{messages.closed}</dt>
                    <dd>{closedDate}</dd>
                  </>
                )}
              </dl>
            </Col>
          </Row>

          <div id="client-new">
            <ClientNew show={this.state.showClientNew} close={this.closeClientNew} onSubmitParent={this.assignTarget} />
          </div>
        </div>
      );
    }

    return null;
  }
}
LeadData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    webApp: state.webApp,
    appIntl: state.intl,
    user: state.login.user,
    watching: state.watching.lead,
    commentNewFormStatus: state.formStatus.leadCommentNew,
    similiarLeads: state.list.similiarLeads,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    watchLead: leadId => {
      dispatch(watchLead(leadId));
    },
    unwatchLead: leadId => {
      dispatch(unwatchLead(leadId));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LeadData)
  )
);
